// i18n-setup.js
import Vue from 'vue';
import VueI18n from 'vue-i18n';

import axios from 'axios';

Vue.use(VueI18n);

const i18n = new VueI18n({
    locale: 'en',
    fallbackLocale: 'en',
});

const loadedLanguages: string[] = [];

function setI18nLanguage(lang: string) {
    i18n.locale = lang;
    axios.defaults.headers.common['Accept-Language'] = lang;
    document.querySelector('html')?.setAttribute('lang', lang);
    return lang;
}

export function loadLanguageAsync({ language, baseUrl, country }: { language: string, baseUrl: string, country?: string }) {
    let lang = language.toLowerCase();
  interface ParamsType {
    language: string;
    country?: string;
  }
  const params:ParamsType = { language: lang };
  if (country) {
      const countryUp = country.toUpperCase();
      lang = `${lang}-${countryUp}`;
      params.country = countryUp;
  }
  if (loadedLanguages.includes(lang)) {
      if (i18n.locale !== lang) setI18nLanguage(lang);
      return Promise.resolve();
  }
  return axios({
      url: '/api/messages/user-personal-account.json',
      method: 'get',
      baseURL: baseUrl,
      params,
  }).then((response) => {
      const msgs = response.data;
      loadedLanguages.push(`${language}-${country}`);
      i18n.setLocaleMessage(`${language}-${country}`, msgs);
      setI18nLanguage(`${language}-${country}`);
  });
}

export default i18n;
